import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/single-tag-selector-v1/single-tag-selector-v1-index';

@Injectable({
    providedIn: 'root'
})
export class SingleTagSelectorV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'single-tag-selector-v1';
    menuTitle: string = "Single Tag Selector";
    deprecated: boolean = false;


    /**
      * 
      * @param field the object data of the field
      * @returns SingleTagSelectorV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.SingleTagSelectorV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsSingleTagSelectorV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsSingleTagSelectorV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        const f =  new fields.SettingsSingleTagSelectorV1Field(field.type, field.position);
        return f.deserialize(field);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsSingleTagSelectorV1FieldComponent> {
        return fieldComponents.SettingsSingleTagSelectorV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillSingleTagSelectorV1FieldComponent> {
        return fieldComponents.FillSingleTagSelectorV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewSingleTagSelectorV1FieldComponent> {
        return fieldComponents.ViewSingleTagSelectorV1FieldComponent;
    }
}

